import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import { formatRupees } from '@porterin/utils/src/helpers/RupeeFormatter';
import React from 'react';

import {
  bookingAmountToPay,
  close,
  note,
  packersAndMovers,
  paymentFailed,
  paymentFailureDesc,
  paymentFailureImgUrl,
} from '../store/PaymentFailureStore';
import styles from '../styles/PaymentFailure.module.scss';

interface PaymentFailureCmpProps {
  payment_amount: string;
  close_modal: () => void;
}

function PaymentFailureCmp({
  payment_amount,
  close_modal,
}: Readonly<PaymentFailureCmpProps>): React.ReactElement {
  return (
    <div className={styles['payment-failure-container']}>
      <div className={styles['main']}>
        <div className={styles['payment-failure-icon']}>
          <NextImageV2
            src={paymentFailureImgUrl}
            width={66.67}
            height={66.67}
            alt="Error icon"
          />
        </div>
        <div className={styles['heading']}>{paymentFailed}</div>
        <div className={styles['sub-heading']}>{packersAndMovers}</div>
        <div className={styles['sub-text']}>{bookingAmountToPay}</div>
        <div className={styles['payment-amount']}>
          {formatRupees(payment_amount)}
        </div>
        <div className={styles['payment-failure-info']}>
          <span className={styles['highlight']}>{note}</span>
          {paymentFailureDesc}
        </div>
      </div>
      <div className={styles['footer']}>
        <button onClick={close_modal} className={styles['footer-cta']}>
          {close}
        </button>
      </div>
    </div>
  );
}

export default PaymentFailureCmp;
